const rebateModeEnum = {
  WINLOSE: "winlose",
  BETAMOUNT: "betamount",
  HYBRID: "hybrid",
  NET_LOSS: "netloss",
};

export default rebateModeEnum;
